var map = {
	"./ai_saas.png": "4ad8",
	"./aimia_saas.png": "864c",
	"./avolux_saas.png": "2d8c",
	"./caimeta_saas.png": "2b97",
	"./hera_saas.png": "bb3a",
	"./home_saas.png": "6138",
	"./proled_saas.png": "3c5c",
	"./sensetrack_saas.png": "e6ed",
	"./vision_saas.png": "c115",
	"./zhimouji_saas.png": "af97"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "4b3b";